import { LARGE_DESKTOP_WIDTH, PHONE_RESOLUTION } from 'src/styles/variables'
import styled from 'styled-components'


export const StyledWrapper = styled.div`
  max-width: ${LARGE_DESKTOP_WIDTH};
  padding: 0 15px;
  margin: 0 auto;
  @media screen and (max-width: ${PHONE_RESOLUTION}) {
    padding: 25px 20px;
  }

  .overflowHidden {
    overflow: hidden;
  }
`
